/* eslint-disable camelcase */
import React, {ReactElement} from 'react';
import {Typography} from '@customink/pigment-react';
import Skeleton from '@mui/material/Skeleton';
import {OrderConfirmationResponse} from '../../models/orderConfirmation';
import './index.scss';

const DetailsPlaceholder: React.FC = () => {
  const mock = [1, 2];
  return (
    <div className="orderDetailsPlaceholder">
      {mock.map(
        (row: number): ReactElement => (
          <Skeleton className="skeletonText" variant="text" key={row} />
        )
      )}
    </div>
  );
};

const OrderConfirmationDetails: React.FC<OrderConfirmationResponse> = (
  data: OrderConfirmationResponse
): ReactElement => {
  const {shipping, storeOwnerEmail} = data;
  if (!data || !shipping) {
    return <DetailsPlaceholder />;
  }
  return (
    <div className="orderDetails">
      <div className="orderDetails-message">
        <Typography variant="h5" gutterBottom>
          Thank you for your purchases!
        </Typography>
        <Typography variant="subHeading" gutterBottom className="order-confirm">
          Your order has been placed.
        </Typography>
      </div>
      <div className="orderDetails-info">
        <div className="contact">
          <Typography variant="subHeading" className="title">
            Contact Information
          </Typography>
          <Typography variant="subHeading" className="email">
            {storeOwnerEmail}
          </Typography>
        </div>
        <div className="address">
          <Typography variant="subHeading" className="title">
            Shipping Address
          </Typography>
          <Typography variant="h6">{shipping.location}</Typography>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmationDetails;
